import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VelicinaSet } from './velicina-set';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-velicina-set-modal-update',
  templateUrl: './velicina-set-modal-update.component.html'
})
export class VelicinaSetModalUpdateComponent
 extends BaseModalUpdateComponent<VelicinaSet>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VelicinaSet>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
